import React, { Component } from 'react';
import './App.css';
import Master from './compoents/master';
import { getConfig } from './data/getConfig';
import queryString from 'query-string';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: "",
      searchObj: "",
      // IsAgent: false,
      // soaid: null
    }
    //this.getURL();
  }

  async getURL() {
    let searchObj = "";
    let searchObj1 = "";
    let IsAgent = true;
    let soaid = "430EE427-5BA2-EA11-823C-E2B33561B8AA";
    if (window.location.search !== "") {
      searchObj1 = await queryString.parse(window.location.search);
      searchObj = await window.location.href;
      //searchObj = "https://www.producermax.com/agent/soa/default.html?agentnpn=11111";
      //searchObj = "https://producermax.com/soa_dev/?Test45-check-778";
      //searchObj = "https://producermax.com/soa/?SREE-HANUMAN-PILLARISETTY-312333333"

      if (searchObj.includes("&")) {
        if ((searchObj1[1] !== undefined && searchObj1[2] !== undefined) && (searchObj1[2] === "TRUE" || searchObj1[2] === "FALSE")) {
          this.setState({
            searchObj: searchObj,
            IsAgent: searchObj1[2] === undefined ? false : (searchObj1[2] === "TRUE" ? true : false),
            soaid: searchObj1[1] === undefined ? "" : searchObj1[1],
            ismpa: searchObj1[3] === undefined ? false : (searchObj1[3] === "TRUE" ? true : false),
          });
        }
        else {
          alert("Please enter a valid link shared by your agent");
          return false
        }
      }
      else {
        this.setState({
          searchObj: searchObj,
          IsAgent: false,
          soaid: "",
          IsMPA: false
        });
      }
    }
    else {
      alert("Please enter a valid link shared by your agent");
      return false
    }
  }

  async getConfigData() {
    let config = await getConfig();
    this.setState({
      config: config
    });
  }

  componentDidMount() {
    this.getURL();
    this.getConfigData();
  }

  render() {
    return (
      <div className="App">
        {(this.state.config !== "" && this.state.searchObj !== "") ? (
          <Master
            config={this.state.config}
            searchObj={this.state.searchObj}
            IsAgent={this.state.IsAgent}
            soaid={this.state.soaid}
            IsMPA={this.state.ismpa}
          />
        )
          : null}
      </div>
    );
  }
}

export default App;
